import { Column } from "@hightouch/htui";
import { Skeleton } from "src/components/loading";

export const PageContentSkeleton = () => (
  <Column gap={6} p={6} flex={1}>
    <Column gap={2}>
      <Skeleton height={24} width={200} />
      <Skeleton height={16} width={120} />
    </Column>
    <Column gap={4}>
      <Skeleton height={120} borderRadius={8} />
      <Skeleton height={120} borderRadius={8} />
    </Column>
  </Column>
);
